import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    MessageStatusDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import type {
    MessageDeliveryStatus
} from "../../type";
import {
    CircleAlert as CircleAlertIcon,
    CheckCheck as CheckCheckIcon,
    CloudOff as CloudOffIcon,
    Clock as ClockIcon,
    Check as CheckIcon,
    type LucideIcon
} from "lucide-react-native";
import {
    MESSAGE_FOOTER_TYPOGRAPHY
} from "../../stylesheet";

export const MESSAGE_STATUS_ICONS: Record<MessageDeliveryStatus, LucideIcon> = {
    delivered: CheckCheckIcon,
    failed: CircleAlertIcon,
    queued: CloudOffIcon,
    read: CheckCheckIcon,
    sending: ClockIcon,
    sent: CheckIcon
};

export const MESSAGE_STATUS_ICON_COLORS: Record<MessageDeliveryStatus, keyof NCoreUIKit.IconContentColors> = {
    delivered: "low",
    failed: "danger",
    sending: "low",
    queued: "low",
    read: "high",
    sent: "low"
};

export const MESSAGE_STATUS_TEXT_COLORS: Record<MessageDeliveryStatus, keyof NCoreUIKit.TextContentColors> = {
    delivered: "low",
    failed: "danger",
    sending: "low",
    queued: "low",
    read: "low",
    sent: "low"
};

export const MESSAGE_STATUS_TEXT_KEYS: Record<MessageDeliveryStatus, keyof NCoreUIKit.Translation> = {
    delivered: "message-delivered",
    sending: "message-sending",
    failed: "message-failed",
    queued: "message-queued",
    read: "message-read",
    sent: "message-sent"
};

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row",
        flexShrink: 1,
        minWidth: 0
    },
    text: {
        flexShrink: 1,
        minWidth: 0
    }
});

export const useStyles = ({
    controlHeights,
    typography,
    spaces
}: MessageStatusDynamicStyleType) => {
    const styles = {
        retry: {
            marginVertical: (typography[MESSAGE_FOOTER_TYPOGRAPHY].lineHeight - controlHeights.small) / 2
        } as Mutable<ViewStyle>,
        container: {
            gap: spaces.spacingXxs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
